module.exports = __webpack_public_path__ + "media/ui-click.a39f3d88.wav";